import { render } from "./VerifySubscriptionEmailPage.vue?vue&type=template&id=aa77b1e8&scoped=true"
import script from "./VerifySubscriptionEmailPage.vue?vue&type=script&lang=js"
export * from "./VerifySubscriptionEmailPage.vue?vue&type=script&lang=js"

import "./VerifySubscriptionEmailPage.vue?vue&type=style&index=0&id=aa77b1e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa77b1e8"]])

export default __exports__